export default function () {
  if (this.$route.name === 'EditDashboardNotification') {
    this.loadNotification()
  }
}
